<div class="flex bg-opacity-0 md:bg-opacity-100 bg-white">
    <div class="hidden md:block max-h-screen w-full relative">
        <img class="h-full w-[inherit] object-cover" alt="background" [src]="bgImage" />
        <a routerLink="/home">
            <img
                class="absolute top-10 left-10 w-[120px] h-[50px]"
                src="/assets/images/shared/brand-logo-white.png"
                alt="logo"
        /></a>
    </div>

    <div class="w-full md:w-[70%] h-screen relative justify-items-center flex">
        <img class="absolute md:hidden w-screen h-screen object-cover -z-10" alt="background" [src]="bgImage" />

        <div class="flex-grow py-4 px-10 xl:px-20 bg-white m-3 rounded-2xl overflow-auto content-center">
            <router-outlet></router-outlet>
        </div>

        <div class="version-container">{{ APP_VERSION }}</div>
    </div>
</div>
